import Constant from '@/const';
import axios from 'axios';

const putProcedure = async (id, payload) => {
  try {
    const response = await axios.put(
      Constant.apiUrl.concat(`/master/procedure/${id}`),
      payload,
    );
    return response;
  } catch (error) {
    this.showErrorAxios(error);
  }
};

export default putProcedure;
